<template>
	<div class="login-wrap">
      <img src="../../static/img/logo.png" alt="" class="logo">
		<div class="login-1" >
			<el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="login">
				<h3 class="title">用户登录</h3>
				<el-form-item prop="account">
					<el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="账号"></el-input>
				</el-form-item>
				<el-form-item prop="checkPass">
					<el-input type="password" v-model="ruleForm2.checkPass" autoComplete="new-password" placeholder="请输入密码" ref="passwordInput" ></el-input>
						<input type="password" style="display: none;" />
				</el-form-item>
				<el-form-item  prop="imgCode" v-if="imgAuth.show" class="img">
						<el-input type="text" v-model="ruleForm2.imgCode" auto-complete="off" placeholder="请输入图形验证码"></el-input>
            <div style="position: relative;margin-left: -80px;width: 100px">
              <img :src="'data:image/jpeg;base64,'+imgAuth.imgPath" @click="getImgCode" />
            </div>

				</el-form-item>
				<el-form-item class="check-wrap">
					<el-checkbox v-model="checked" checked class="remember">记住用户名</el-checkbox>
				</el-form-item>
				<el-form-item style="width:100%;">
					<el-button type="primary" style="" @click.native.prevent="handleSubmit2" :loading="logining" class="btn">登录
					</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import http from '@/http'
	import jsCookie from 'js-cookie'
	import md5 from 'js-md5';
	import sha512 from 'js-sha512';

	export default {
		data() {
			return {
				logining: false,
				ruleForm2: {
					account: jsCookie.get('USERNAME'),
					checkPass: '',
					imgCode: ''
				},
				rules2: {
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}],
					imgCode: [{
						required: true,
						message: '请输入图形验证码',
						trigger: 'blur'
					}]
				},
				checked: true,
				imgAuth: {
					imgToken: null,
					imgPath: null,
					show: false
				},
			}
		},
		created() {},
		methods: {
			// 记住用户名
			remember(val) {
				if (this.checked) {
					jsCookie.set('USERNAME', this.ruleForm2.account, {
						expires: 10
					});
				} else {
					jsCookie.remove('USERNAME');
				}
			},
			getImgCode() {
				let _this = this
				http.post(_this.globalConfig.domain.backstage + "/verify/imgCode", {}, (response) => {
					let result = response.data;
					if (result.success) {
						_this.imgAuth.imgPath = result.data.imgPath
						_this.imgAuth.imgToken = result.data.imgToken
					}
				});
			},
			handleSubmit2(ev) {
				var _this = this;
        window.sessionStorage.setItem('navStatus','/main.html');
				_this.$refs.ruleForm2.validate((valid) => {
					if (valid) {
						_this.logining = true;
						var loginParams = {
							account: _this.ruleForm2.account,
							// password: _this.ruleForm2.checkPass
							password: sha512(_this.ruleForm2.account.trim() + md5(_this.ruleForm2.checkPass))

						};
						if (_this.imgAuth.imgToken) {
							loginParams.imgCode = `${_this.imgAuth.imgToken}_${_this.ruleForm2.imgCode}`
						}
						http.post(_this.globalConfig.domain.backstage + "/login/login", loginParams, (response) => {
							_this.logining = false;
							let result = response.data;
							if (result.success) {
								_this.remember()
								_this.$store.dispatch('setLocalUser', result.data);
								_this.$router.push({
									path: '/main.html'
								});
							} else if (result.code == 10601) {
								_this.$message.error('请输入正确的验证码');
								_this.imgAuth.show = true
								_this.getImgCode()
							} else {
								_this.$message.error(result.description || '登录失败');
								_this.ruleForm2.checkPass = '';
								_this.$refs.passwordInput.$el.querySelector('input').focus();
								if (_this.imgAuth.show) {
									_this.imgAuth.imgToken = ''
									_this.getImgCode();
								}
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.login-wrap {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		min-width: 1000px;
		z-index: -10;
		zoom: 1;
		background: url(../../static/img/login_bg.png) no-repeat center 0;
		background-size: cover;

		>div {
			margin: 300px 0 0 6rem;
		}

	}
  .logo{
    position: absolute;
    top: 50px;
    left: 80px;
    height: 80px;
    width: auto;
  }
  .login-1{
    text-align:center;

    position:absolute
  }
  /deep/.check-wrap .el-checkbox{
    color: #409EFF !important;
  }
.login{
  background: url(../../static/img/login-border.png) no-repeat center 0;
   height: 443px !important;
   width: 443px !important;
  background-size: 100%;
  /*margin-left: 1250px;*/
  .title {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    line-height: 29px;
    color: #11FFEF;
    padding: 20px 0;
  }
  .remember {
    margin: 0px 0px 35px 0px;
  }

  /deep/ .el-input__inner {
    background: #130c94;
    border: none;
    border-bottom: 1px solid #11FFEFFF;
    width: 400px;
    color: #11FFEFFF;
  }
  /deep/ .el-form-item__error{
    margin-left: 30px;
  }

}

	.check-wrap {
		text-align: right;
    margin-right: 20px;

		.el-checkbox {
			margin-bottom: 0;
		}

		.el-checkbox {
			color: #022F4A;
		}
	}

  .img{
    /deep/ .el-form-item__content{
      display: flex;
    }
    /deep/ .el-input__inner{
      margin:0 20px
    }
    img {
      vertical-align: middle;
      cursor: pointer;
      // width: 100px;
      height: 30px;
      /*width: 30%;*/
      // background-color: red;
    }
  }


  .btn{
    width: 330px;
    height: 45px;
    background: linear-gradient(180deg, #11FFEF 0%, #00B1FF 100%);
    box-shadow: 0px 3px 6px rgba(38, 169, 227, 0.3);
    opacity: 1;
    border-radius: 100px;
    &:hover{
      opacity: 0.8;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue